module.exports = __webpack_public_path__ + "static/media/map.b57f8d46.svg";